export const environment = {
  production: false,
  api: 'https://dev.jadeapi.com/api/jade-api/',
  imagesServerPath: `https://jadeservice.azurewebsites.net/MyImages/`,
  offersServerPath: `https://jadeservice.azurewebsites.net/MyOffers/`,
  firebase: {
    apiKey: 'AIzaSyAtclgl5zDlLvs9ZFBL_tnllG1fGfnJgM4',
    authDomain: 'jadeproject-86ee2.firebaseapp.com',
    databaseURL: 'https://jadeproject-86ee2.firebaseio.com',
    projectId: 'jadeproject-86ee2',
    storageBucket: 'jadeproject-86ee2.appspot.com',
    messagingSenderId: '12526627942'
  }
};